(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ldd-releases-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-ldd-releases]');
    roots.forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      const player = root.querySelector('[data-release-player]');
      const playerTitle = root.querySelector('[data-release-player-title]');
      const playerImage = root.querySelector('[data-release-player-image]');
      const playerToggle = root.querySelector('[data-release-player-toggle]');
      const artistFilter = root.querySelector('[data-artist-filter]');
      const artistSearch = root.querySelector('[data-artist-search]');
      const artistStatus = root.querySelector('[data-artist-status]');
      const artistList = root.querySelector('[data-artist-list]');
      const artistSelected = root.querySelector('[data-artist-selected]');
      const count = root.querySelector('[data-release-count]');
      const grid = root.querySelector('[data-release-grid]');
      const loadWrap = root.querySelector('[data-release-load-wrap]');
      const loadStatus = root.querySelector('[data-release-load-status]');
      const sortArtist = root.querySelector('[data-artist-sort]');
      const originalCount = count.textContent;
      let originalCards = grid.innerHTML;
      let currentArtist = '';
      let catalogPromise = null;
      let artistNames = [];
      let audio = null;
      let activeButton = null;
      const cleanTitle = (title) => title.replace(/^[A-Z]{2,}[A-Z0-9]*\s*\d+(?:-\d+)?\s*[-–]\s*/i, '');

      const extractArtists = (title) => {
        const catalogPrefix = title.match(/^[A-Z]{2,}[A-Z0-9]*\s*\d+(?:-\d+)?\s*[-–]\s*/i);
        const release = catalogPrefix ? title.slice(catalogPrefix[0].length) : title;
        const byline = (release.split(/['‘“"]/)[0].split(' - ')[0] || '').trim();
        if (!byline || /^(various|low down deep|fixes ep|[A-Z]+\s*\d+|test product)/i.test(byline)) return [];
        return byline.split(/\s+(?:&|and|feat\.?|ft\.?|vs\.?)\s+|,\s*|\s+x\s+/i)
          .map((name) => name.replace(/\([^)]*\)/g, '').trim())
          .filter((name) => name.length >= 3 && name.length <= 35 && !/^\d/.test(name) && !/exclusive|dub pack|classics|\bvol(?:ume)?\b/i.test(name));
      };

      const loadCatalog = async () => {
        if (catalogPromise) return catalogPromise;
        catalogPromise = (async () => {
          const products = [];
          const base = new URL(root.dataset.artistIndexUrl, window.location.origin);
          const sort = new URLSearchParams(window.location.search).get('sort_by');
          if (sort) base.searchParams.set('sort_by', sort);
          let next = base.toString();
          let pages = 0;
          while (next && pages < 30) {
            const response = await fetch(next);
            if (!response.ok) throw new Error('Artist index unavailable');
            const page = await response.json();
            if (!Array.isArray(page.products)) throw new Error('Invalid artist index');
            products.push(...page.products);
            artistStatus.textContent = `Loading artists • ${products.length} of ${page.total || products.length} releases`;
            next = page.next ? new URL(page.next, window.location.origin) : null;
            if (next) next.searchParams.set('view', 'artist-index');
            next = next ? next.toString() : null;
            pages += 1;
          }
          if (next) throw new Error('Artist index incomplete');
          const distinctArtists = new Map();
          products.flatMap((product) => extractArtists(product.title)).forEach((name) => {
            const key = name.toLocaleLowerCase();
            if (!distinctArtists.has(key)) distinctArtists.set(key, name);
          });
          artistNames = [...distinctArtists.values()]
            .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
          artistStatus.textContent = 'Choose an artist';
          return products;
        })().catch((error) => {
          catalogPromise = null;
          artistStatus.textContent = 'Could not load artists. Close and reopen to retry.';
          throw error;
        });
        return catalogPromise;
      };

      const makeIcon = (path) => {
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 24 24');
        svg.setAttribute('aria-hidden', 'true');
        const shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        shape.setAttribute('d', path);
        svg.append(shape);
        return svg;
      };

      const makeCard = (product) => {
        const article = document.createElement('article');
        article.className = 'ldd-release-card';
        const imageLink = document.createElement('a');
        imageLink.className = 'ldd-release-card__image';
        imageLink.href = product.url;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title;
          image.loading = 'lazy';
          image.sizes = '(min-width: 1200px) 15vw, (min-width: 750px) 31vw, 47vw';
          imageLink.append(image);
        }
        if (root.classList.contains('ldd-releases--dub-packs') && product.comparePrice) {
          const ribbon = document.createElement('span');
          ribbon.className = 'ldd-release-card__sale-ribbon';
          ribbon.textContent = 'SALE';
          imageLink.append(ribbon);
        }
        const heading = document.createElement('h2');
        const titleLink = document.createElement('a');
        titleLink.href = product.url;
        titleLink.textContent = cleanTitle(product.title);
        heading.append(titleLink);
        const footer = document.createElement('div');
        footer.className = 'ldd-release-card__footer';
        let price;
        if (root.classList.contains('ldd-releases--dub-packs') && product.comparePrice) {
          price = document.createElement('span');
          price.className = 'ldd-release-card__price';
          const oldPrice = document.createElement('s');
          oldPrice.textContent = product.comparePrice;
          const newPrice = document.createElement('strong');
          newPrice.textContent = product.price;
          price.append(oldPrice, newPrice);
        } else {
          price = document.createElement('strong');
          price.textContent = product.price;
        }
        const actions = document.createElement('div');
        actions.className = 'ldd-release-card__actions';
        if (product.audio) {
          const play = document.createElement('button');
          play.type = 'button';
          play.className = 'ldd-release-card__play';
          play.dataset.releaseAudio = product.audio;
          play.dataset.releaseTitle = product.title;
          if (product.image) play.dataset.releaseImage = product.image;
          play.setAttribute('aria-label', `Play preview: ${product.title}`);
          play.title = 'Play preview';
          play.append(makeIcon('M7 4 20 12 7 20Z'));
          actions.append(play);
        }
        const form = document.createElement('form');
        form.method = 'post';
        form.action = '/cart/add';
        form.className = 'ldd-release-card__form';
        const variant = document.createElement('input');
        variant.type = 'hidden';
        variant.name = 'id';
        variant.value = product.variant;
        const cart = document.createElement('button');
        cart.type = 'submit';
        cart.className = 'ldd-release-card__cart' + (product.available ? '' : ' is-sold-out');
        cart.setAttribute('aria-label', product.available ? `Add ${product.title} to cart` : `Sold out: ${product.title}`);
        if (product.available) {
          cart.title = 'Add to cart';
          const icon = makeIcon('M3 9h18l-2 11H5L3 9Z');
          const handle = makeIcon('m8 9 4-6 4 6');
          const plus = makeIcon('M12 12v5M9.5 14.5h5');
          icon.append(...handle.childNodes, ...plus.childNodes);
          cart.append(icon);
          const label = document.createElement('span');
          label.className = 'ldd-icon-label';
          label.textContent = 'Add to cart';
          cart.append(label);
        } else {
          cart.textContent = 'Sold out';
          cart.disabled = true;
        }
        form.append(variant, cart);
        actions.append(form);
        footer.append(price, actions);
        article.append(imageLink, heading, footer);
        return article;
      };

      const renderArtists = (filter = '') => {
        artistList.replaceChildren();
        const all = document.createElement('button');
        all.type = 'button';
        all.textContent = 'All artists';
        all.dataset.artistOption = '';
        artistList.append(all);
        const options = artistNames.filter((name) => name.toLowerCase().includes(filter.toLowerCase()));
        options.forEach((name) => {
          const option = document.createElement('button');
          option.type = 'button';
          option.textContent = name;
          option.dataset.artistOption = name;
          if (name === currentArtist) option.setAttribute('aria-current', 'true');
          artistList.append(option);
        });
        artistStatus.textContent = options.length ? `${options.length} artists` : 'No artists found';
      };

      const showArtist = async (name, updateUrl = true) => {
        if (name && !currentArtist) originalCards = grid.innerHTML;
        currentArtist = name;
        artistSelected.textContent = name || 'Artist';
        sortArtist.value = name;
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (name) url.searchParams.set('artist', name);
          else url.searchParams.delete('artist');
          window.history.replaceState(null, '', url);
        }
        if (!name) {
          grid.innerHTML = originalCards;
          count.textContent = originalCount;
          if (loadWrap) loadWrap.hidden = false;
          return;
        }
        count.textContent = `Finding ${name} releases…`;
        try {
          const products = await loadCatalog();
          const escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          const artistMatch = new RegExp(`(^|[^a-z0-9])${escaped}(?=$|[^a-z0-9])`, 'i');
          const matches = products.filter((product) => extractArtists(product.title).some((artist) => artistMatch.test(artist)));
          const fragment = document.createDocumentFragment();
          matches.forEach((product) => fragment.append(makeCard(product)));
          if (!matches.length) {
            const empty = document.createElement('p');
            empty.className = 'ldd-releases__empty';
            empty.textContent = 'No releases found for this artist.';
            fragment.append(empty);
          }
          grid.replaceChildren(fragment);
          count.textContent = `${matches.length} ${matches.length === 1 ? 'release' : 'releases'} by ${name}`;
          if (loadWrap) loadWrap.hidden = true;
        } catch (error) {
          count.textContent = 'Could not load artist releases. Please try again.';
        }
      };

      artistFilter.addEventListener('toggle', async () => {
        if (!artistFilter.open) return;
        try {
          await loadCatalog();
          renderArtists(artistSearch.value);
          artistSearch.focus();
        } catch (error) {}
      });
      artistSearch.addEventListener('input', () => renderArtists(artistSearch.value));
      artistList.addEventListener('click', (event) => {
        const option = event.target.closest('[data-artist-option]');
        if (!option) return;
        artistFilter.open = false;
        showArtist(option.dataset.artistOption);
      });
      const initialArtist = new URLSearchParams(window.location.search).get('artist');
      if (initialArtist) showArtist(initialArtist, false);

      if (loadWrap && 'IntersectionObserver' in window) {
        root.classList.add('is-auto-load');
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting) || currentArtist) return;
          const link = root.querySelector('[data-release-load-more]');
          if (link && link.dataset.loading !== 'true' && link.dataset.autoloadError !== 'true') link.click();
        }, { rootMargin: '500px 0px' });
        observer.observe(loadWrap);
      }

      root.addEventListener('change', (event) => {
        if (event.target.matches('[data-release-sort]')) event.target.form.submit();
      });

      root.addEventListener('submit', async (event) => {
        const form = event.target.closest('.ldd-release-card__form');
        if (!form) return;
        event.preventDefault();
        const button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        button.disabled = true;
        const original = button.innerHTML;
        const originalLabel = button.getAttribute('aria-label');
        button.textContent = 'Adding…';
        button.style.width = 'auto';
        button.style.fontSize = '10px';
        try {
          const url = (window.Shopify?.routes?.root || '/') + 'cart/add.js';
          const response = await fetch(url, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          const item = await response.json();
          if (!response.ok) throw new Error(item.description || 'Could not add to cart');
          document.body.dispatchEvent(new CustomEvent('label:modalcart:afteradditem'));
          button.textContent = 'Added';
          button.setAttribute('aria-label', 'Added to cart');
        } catch (error) {
          button.textContent = 'Try again';
          button.setAttribute('aria-label', error.message);
        }
        setTimeout(() => {
          button.innerHTML = original;
          button.style.removeProperty('width');
          button.style.removeProperty('font-size');
          if (originalLabel) button.setAttribute('aria-label', originalLabel);
          button.disabled = false;
        }, 1800);
      });

      root.addEventListener('click', async (event) => {
        const playButton = event.target.closest('[data-release-audio]');
        if (playButton) {
          event.preventDefault();
          if (activeButton === playButton && audio && !audio.paused) {
            audio.pause();
            playButton.classList.remove('is-playing');
            player.classList.add('is-paused');
            playerToggle.textContent = '▶';
            return;
          }
          if (audio) audio.pause();
          if (activeButton) activeButton.classList.remove('is-playing');
          activeButton = playButton;
          audio = new Audio(playButton.dataset.releaseAudio);
          playerTitle.textContent = playButton.dataset.releaseTitle;
          playerImage.style.backgroundImage = playButton.dataset.releaseImage ? `url("${playButton.dataset.releaseImage}")` : '';
          player.hidden = false;
          player.classList.remove('is-paused');
          playerToggle.textContent = 'Ⅱ';
          playButton.classList.add('is-playing');
          audio.addEventListener('ended', () => {
            playButton.classList.remove('is-playing');
            player.classList.add('is-paused');
            playerToggle.textContent = '▶';
          });
          await audio.play();
          return;
        }

        const loadMore = event.target.closest('[data-release-load-more]');
        if (loadMore) {
          event.preventDefault();
          if (loadMore.dataset.loading === 'true') return;
          loadMore.dataset.loading = 'true';
          if (loadStatus) loadStatus.textContent = 'Loading more releases…';
          const originalText = loadMore.textContent;
          loadMore.textContent = '…';
          try {
            const response = await fetch(loadMore.href);
            if (!response.ok) throw new Error('Could not load releases');
            const html = await response.text();
            const documentCopy = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = documentCopy.querySelector('[data-release-grid]');
            const nextLink = documentCopy.querySelector('[data-release-load-more]');
            if (nextGrid) root.querySelector('[data-release-grid]').insertAdjacentHTML('beforeend', nextGrid.innerHTML);
            if (nextLink) {
              loadMore.href = nextLink.href;
              loadMore.textContent = originalText;
              loadMore.dataset.loading = 'false';
              if (loadStatus) loadStatus.textContent = 'Scroll for more releases';
            } else {
              loadMore.closest('.ldd-releases__load-wrap').remove();
            }
          } catch (error) {
            loadMore.textContent = originalText;
            loadMore.dataset.loading = 'false';
            loadMore.dataset.autoloadError = 'true';
            root.classList.remove('is-auto-load');
            if (loadStatus) loadStatus.textContent = 'Could not load more releases';
          }
          return;
        }

        if (event.target.closest('[data-release-player-toggle]') && audio) {
          if (audio.paused) {
            audio.play();
            player.classList.remove('is-paused');
            playerToggle.textContent = 'Ⅱ';
            if (activeButton) activeButton.classList.add('is-playing');
          } else {
            audio.pause();
            player.classList.add('is-paused');
            playerToggle.textContent = '▶';
            if (activeButton) activeButton.classList.remove('is-playing');
          }
        }

        if (event.target.closest('[data-release-player-close]')) {
          if (audio) audio.pause();
          if (activeButton) activeButton.classList.remove('is-playing');
          player.hidden = true;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
